var exports = {
  "V": "x0a7806d5--38dbef--search-icon",
};

module.exports = exports;
